import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
//
// Components
//
import { VSpecProtectionProducts } from './v-spec-protection-products';
import { AppMenuComponentModule } from '../../../shared/components/app-menu/app-menu.module';
import { VehicleDetailHeaderComponentModule } from '../../../shared/components/vehicle-detail-header/vehicle-detail-header.component.module';
import { SharedModule } from '../../../shared/shared.module';
import {VSpecProductCardModule} from '../../../../lib/angular/component/common/rti-product-card/rti-product.module';
//
// Library Components
//
import { RtiCardModule } from '../../../../lib/angular/component/common/rti-card/rti-card.module';
import { RtiCarouselModule } from '../../../../lib/angular/component/common/rti-carousel/rti-carousel.module';
import { RtiCarouselItemModule } from '../../../../lib/angular/component/common/rti-carousel/rti-carousel-item/rti-carousel-item.module';

import { RtiDirectiveModule } from '../../../../lib/angular/directive/rti-directive.module';
import { RtiDealerOptionDetailModule } from '../../../../lib/angular/component/dealer/rti-dealer-option-detail/rti-dealer-option-detail.module';

@NgModule({
  imports: [
    CommonModule,
    RtiCardModule,
    RtiCarouselModule,
    RtiCarouselItemModule,
    RtiDirectiveModule,
    RtiDealerOptionDetailModule,
    MatIconModule,
    AppMenuComponentModule,
    VehicleDetailHeaderComponentModule,
    SharedModule,
    VSpecProductCardModule
  ],
  declarations: [
    VSpecProtectionProducts
  ],
  exports: [
    VSpecProtectionProducts
  ]
})

export class VSpecProtectionProductsModule {
}
